
import React from 'react';

const ChallengeRewards = ({
  classes,
  extraBenefits,
  supportedMult,
  goalMult,
  implementedMult,
  starImg,
  coinsImg,
}) => {
  return (
    <div className={classes.reward_panel}>
      <div className={classes.extraBenefitWrp} style={{ borderRight: '1px solid #EBEBEB' }}>
        <img src={extraBenefits} className={classes.icon_img} alt="Extra Benefits" />
        <div className={classes.extracontent}>
          <div className={classes.reward_header}>Get extra benefits:</div>
          <div className={classes.extraList}>
            <div className={classes.extraItem}>
              <p className={classes.extraBenefitValue}>{supportedMult || 'X'}</p>
              <p className={classes.extraBenefitName}>Supported</p>
            </div>
            <div className={classes.extraItem}>
              <p className={classes.extraBenefitValue}>{goalMult || 'X'}</p>
              <p className={classes.extraBenefitName}>Approved</p>
            </div>
            <div className={classes.extraItem}>
              <p className={classes.extraBenefitValue}>{implementedMult || 'X'}</p>
              <p className={classes.extraBenefitName}>Implemented</p>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.inner_reward_panel} style={{ borderRight: '1px solid #EBEBEB' }}>
        <img src={starImg} className={classes.icon_img} alt="star icon" />
        <div style={{ paddingLeft: '16px' }}>
          <div className={classes.reward_header}>Reward:</div>
          <div className={classes.reward_info}>
            Work with a team to pitch the idea to get funding building it along with the team
          </div>
        </div>
      </div>

      <div className={classes.inner_reward_panel}>
        <img src={coinsImg} className={classes.icon_img} alt="coins icon" />
        <div style={{ paddingLeft: '16px' }}>
          <div className={classes.reward_header}>Who gets the reward:</div>
          <div className={classes.reward_info}>
            Users whose ideas become pilot projects
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeRewards;
